import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SpareStockRepository } from './repositories/spare-stock-repo';
import { SpareStockAdapter } from './spare-stock-adapter';
import { SpareStockController } from './spare-stock-controller';
import { SpareStockService } from './spare-stock-service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';


@Module({
    imports: [
        TypeOrmModule.forFeature([SpareStockRepository]),
    ],
    controllers: [SpareStockController],
    providers: [SpareStockService, SpareStockAdapter,ApplicationExceptionHandler],
})



export class SpareStockModule {

}